export default "__VITE_ASSET__D75Qp4Qw__"